
import { Mixins, Component, Prop } from 'vue-property-decorator';
import BScroll from 'better-scroll';
import { IFileCheck } from '@/types/question.d';
import noData from '@/components/noData/index.vue';
import PageMixin from '@/views/Home/mixins/pageMixin';
import BsMixin from '@/views/Home/mixins/bsMixin';
import api from '@/api/question';
import Box from './box.vue';

@Component({
  components: {
    Box,
    noData,
  },
})
export default class ListContent extends Mixins(PageMixin, BsMixin) {
  private loading: boolean = true;

  private datas: Array<any> = [];

  private bs?: BScroll;

  public $refs!: {
    content: Element,
    wrapper: Element,
  }

  private flag: boolean = true;

  private height: number = 0;

  private selects: Array<string> = [];

  mounted() {
    this.page.pageSize = 50;
    this.getData();
    this.bs = this.initBS(this.$refs.content);
    this.bs.on('scrollEnd', (cood: any) => {
      if (cood.y === 0) return;
      const contentHeight: number = this.$refs.content.clientHeight;
      const wrapperHeight: number = Math.abs(this.$refs.wrapper.getBoundingClientRect().height);
      if (this.datas.length === (this.page.total || 0)) return;
      if (this.flag) return;
      if (contentHeight + Math.abs(cood.y) > wrapperHeight - 10) {
        this.height = Math.abs(cood.y);
        this.flag = true;
        this.page.pageNo += 1;
        this.getData();
      }
    });
  }

  getData(refresh: boolean = false, params?: object) {
    this.loading = true;
    if (refresh) {
      this.datas = [];
      this.page.pageNo = 1;
      this.page.total = 0;
      this.height = 0;
      this.selects = [];
    }
    this.page.params = params;
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
    api.getQuestion(data).then((res: any) => {
      this.page.total = res.totalElements;
      const result: Array<any> = res.content && res.content.map((que: any) => ({
        pid: que.id,
        name: que.title,
        imgUrl: que.context,
        status: 'success',
        errors: [],
        object: que,
      }));
      /* eslint-disable no-unused-expressions */
      result && result.length > 0 && this.datas.push(...result);
      this.loading = false;
      this.flag = false;
    }).catch(() => {
      this.flag = false;
      this.loading = false;
    });
  }

  /**
   */
  getSelectList(): Array<IFileCheck> {
    return this.datas.filter((em: any) => this.selects.includes(em.pid));
  }

  /**
   * @author Terry
   * @description 处理选中点击事件
   */
  handleCheck(data: { pid: string, flag: string }) {
    if (data.flag === 'check') this.selects.push(data.pid);
    else this.selects = this.selects.filter((em: any) => em !== data.pid);
    this.$emit('handleAllotVis', this.selects.length);
  }
}
